import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { UserRole } from "@green0meter/api-client";

import { CSRD_CONFIG } from "./config";

import { useUserStore } from "@store/user";
import WelcomeBannerContainer from "@components/main/co2/hub/WelcomeBanner";
import CollectData from "@components/main/co2/hub/CollectData";
import Reports from "@components/main/co2/hub/Reports";
import Overview from "@components/main/co2/hub/Overview";
import { Box, Grid } from "@components/base";

const CsrdHubPage: FC = () => {
  const { t } = useTranslation();
  const { user } = useUserStore();
  const canAccessReports =
    user?.role !== UserRole.Respondent && user?.role !== UserRole.Viewer;

  return (
    <Box mb={6}>
      <Grid container spacing={3}>
        <WelcomeBannerContainer
          title={t(CSRD_CONFIG.welcomeBanner.titleKey)}
          text={t(CSRD_CONFIG.welcomeBanner.textKey)}
          color={CSRD_CONFIG.welcomeBanner.color}
          icon={CSRD_CONFIG.welcomeBanner.icon}
        />
        <Grid size={12}>
          <CollectData
            formBaseType={CSRD_CONFIG.formBaseType}
            titleKey={t(CSRD_CONFIG.collectData.titleKey)}
            descriptionKey={t(CSRD_CONFIG.collectData.descriptionKey)}
            color={CSRD_CONFIG.collectData.color}
            icon={CSRD_CONFIG.collectData.icon}
            buttonTextKey={t(CSRD_CONFIG.collectData.buttonTextKey)}
            noFormsTextKey={t(CSRD_CONFIG.collectData.noFormsTextKey)}
          />
        </Grid>
        {canAccessReports && (
          <Grid size={12}>
            <Reports
              formBaseType={CSRD_CONFIG.formBaseType}
              title={t(CSRD_CONFIG.reports.titleKey)}
              type={CSRD_CONFIG.reports.type}
              noReportsText={t(CSRD_CONFIG.reports.noReportsTextKey)}
              fillFormText={t(CSRD_CONFIG.reports.fillFormTextKey)}
            />
          </Grid>
        )}
        <Grid size={12}>
          <Overview
            title={t(CSRD_CONFIG.overview.titleKey)}
            dashboardPath={CSRD_CONFIG.overview.dashboardPath}
            viewDashboardText={t(CSRD_CONFIG.overview.viewDashboardTextKey)}
            reportPageId={CSRD_CONFIG.overview.reportPageId}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default CsrdHubPage;
